import ReviewTabBar, { ReviewTab, ReviewTabBarProps, ReviewTabItem } from './reviewTabBar'

// No logic — passthrough kept for the two-file pattern; containers resolve labels.
const ReviewTabBarWrapper = (props: ReviewTabBarProps) => {
    return <ReviewTabBar {...props} />
}

export { ReviewTabBarWrapper }
export type { ReviewTab, ReviewTabBarProps, ReviewTabItem }
export default ReviewTabBarWrapper
